export enum FileTransferInitiator {
  Http = "Http",
  AsperaConnectFasp = "AsperaConnectFasp",
}
